import IntegrationTable from "@/components/shared/IntegrationTable/IntegrationTable";
import MundWebhook from "../icons/MundWebhook";
import WebhookIcon from "../icons/Webhook";
import { integrationFieldPresets } from "@/components/shared/IntegrationTable/integrationFieldPresets";
import { useTranslation } from "react-i18next";
import { paymentStatus } from "@/utils/paymentMethods";
import { useAuth } from "@/auth/Auth";
import { SUBSCRIPTION_ACTIVE_STATUSES } from "@/utils/integrationSubscription";
import { useMemo } from "react";

export default function Webhook() {
  const { t } = useTranslation("common");
  const { authData } = useAuth();

  const subscriptionStatuses = useMemo(
    () => (authData?.can_offer_recurring ? [...SUBSCRIPTION_ACTIVE_STATUSES] : []),
    [authData?.can_offer_recurring],
  );

  return (
    <IntegrationTable
      integrationKey="webhook"
      title="Webhook"
      main_icon={<MundWebhook />}
      icon={<WebhookIcon />}
      fields={[
        integrationFieldPresets.postback_url,
        integrationFieldPresets.status,
      ]}
      fixedOptions={{
        active_statuses: [
          ...paymentStatus,
          "abandoned_cart",
          "initiate_checkout",
          "chargeback",
          ...subscriptionStatuses,
        ],
      }}
      fieldLabels={{
        payment_status: t("event_type"),
      }}
    />
  );
}
